// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const VolumeOnFill = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M14.724 28.322c-.974 0-1.704-.249-2.191-.745-.487-.506-.73-1.275-.73-2.306v-5.486c0-.955.21-1.67.63-2.148L28.76 33.95c-.114.41-.305.71-.573.902a1.608 1.608 0 0 1-.96.286c-.324 0-.634-.071-.93-.215-.296-.143-.611-.372-.945-.687l-6.188-5.786a.515.515 0 0 0-.358-.13h-4.082ZM28.86 26.23l-9.94-9.912h.43a.342.342 0 0 0 .243-.114l5.758-5.343c.372-.344.692-.592.96-.745.266-.162.567-.243.901-.243.488 0 .884.167 1.19.501.305.325.458.721.458 1.189V26.23Zm4.955 10.412-24.55-24.52a1.051 1.051 0 0 1-.314-.774c0-.315.105-.578.315-.788.22-.22.482-.324.788-.315a1.1 1.1 0 0 1 .787.315l24.521 24.521c.22.22.33.477.33.773 0 .306-.11.569-.33.788a1 1 0 0 1-.773.33c-.306 0-.564-.11-.774-.33Z"
			fill="#fff"
		/>
	</svg>
);
export default VolumeOnFill;
